<template>
    <Modal
        v-model="props.isShowModel"
        :closable="false"
        loading
        :draggable="true"
        :reset-drag-position="true"
        :mask-closable="false"
        width="1020"
        :fullscreen="mobileDevice"
        :class="mobileDevice ? 'mobileDevice' : ''"
        class="step-model">
        <template #header>
            <div></div>
        </template>
        <div class="content">
            <div class="close" @click="close">
                <img src="@/assets/close.png" alt="" />
            </div>
            <div class="step-box"  v-show="upStep == '0'">
                <div class="m-title">
                    Upload a PDF
                </div>
                <div class="s-title">
                    Import a PDF file to use the sildesOrator
                </div>
            </div>
            <div class="step-box"  v-show="upStep == '1'">
                <div class="m-title two">
                    Generate narration
                </div>
                <div class="s-title">
                    Generating narration takes about one minute. If you skip it, you can enter document editing and continue to edit the narration.
                </div>
            </div>

            <div class="step-box"  v-show="upStep == '2'">
                <div class="m-title three">
                    3D avatars and voices
                </div>
                <div class="s-title">
                    Choose your own avatar and voice.
                </div>
            </div>
            <div class="center">
                <YuUpload v-show="upStep == '0'"></YuUpload>
                <YuGenerate  ref="yuGenerateModel"
                    v-if="upStep == '1'"
                    @changeGenerat="changeGenerat"></YuGenerate>
                <YuModel
                    ref="yuModel"
                    :isComfirm="isComfirm"
                    v-if="upStep == '2'"
                    ></YuModel>
            </div>
        </div>
        <template #footer>
            <div class="footer-btn" v-show="upStep == '1'">
                <!-- <div class="y-btn cancel" @click="close">{{ props.cancelText }}</div> -->
                <Button
                    class="y-btn ok"
                    :loading="GenerateLoading"
                    @click="next">
                    {{ GenerateLoading ? "Generating..." : "Done" }}
                </Button>
            </div>

            <div class="footer-btn" v-show="upStep == '2'">
                <div class="y-btn cancel" @click="close">Cancel</div>
                <Button class="y-btn ok" :loading="isComfirm" @click="Confirm"
                    >Confirm</Button
                >
            </div>
        </template>
    </Modal>
</template>

<script setup>
import { ref, computed, watch,getCurrentInstance } from "vue";
import YuUpload from "./upload-step/Yu-upload.vue";
import YuGenerate from "./upload-step/Yu-generate.vue";
import YuModel from "./upload-step/Yu-model.vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { useMixinMobileDevice } from "@/mixins/mobileDevice";
const { mobileDevice, Orientation } = useMixinMobileDevice();
const router = useRouter();
const store = useStore();
const upStep = computed(() => store.state.app.upStep);
const fileId = computed(() => store.state.file.fileId);
const isComfirm = ref(false);
const isGuide = computed(() => store.state.app.isGuide);
const GenerateLoading = ref(!isGuide.value);
const yuModel = ref(null);
const yuGenerateModel = ref(null)
const emits = defineEmits(["close", "sure"]);

const { proxy } = getCurrentInstance();
const props = defineProps({
    isShowModel: Boolean,
    close: Function,
    sure: Function,
    okText: {
        type: String,
        default: "Ok",
    },
    cancelText: {
        type: String,
        default: "Cancel",
    },
    text: String,
    contentText: String,
    modelType: String,
});

const changeGenerat = (type) => {
    console.log(type);
    GenerateLoading.value = type;
};

const setUpStep = (step) => {
    console.log(step);
    store.dispatch("app/setUpStep", step);
    console.log(upStep.value);
};

const close = () => {
    GenerateLoading.value = true;
    emits("close");
};

const next = () => {

    proxy.$creatLoading.show({
        txt: "loading...",
    });
    yuGenerateModel.value.checkAndSaveVoiceOver().then(() => {
        proxy.$creatLoading.hide()
        store.dispatch("app/setUpStep", 2);
    });
};

const Confirm = () => {
    console.log("跑完啦");
    proxy.$creatLoading.show({
        txt: "loading...",
    });
    yuModel.value.comfirm().then((res) => {
        isComfirm.value = false;

        proxy.$creatLoading.hide()
        router.push({
            name: "play", // 路由名称
            params: { bid: fileId.value }, // 路由参数
        });
        store.dispatch("file/upLoadModel", false);
        isComfirm.value = true;
        GenerateLoading.value = true;
        emits("close");
    });
};
</script>
<style lang="less">
.step-model {
    .ivu-modal-content {
        border-radius: 20px !important;
        width: 1020px;
        height: 700px;
        background: #f4f4ffff;
    }
    .ivu-modal-body {
        padding: 0 !important;
    }
    .demo-spin-icon-load {
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    &.ivu-modal-fullscreen {
        width: 100% !important;
        height: 100vh !important;
        left: 0% !important;
        top: 0% !important;
        // transform: translate(-50%, -50%) !important;
        .ivu-modal-content {
            border-radius: 0px !important;
            height: 100%;
        }
        .ivu-modal-body {
            overflow: visible !important;
        }
    }
}
</style>
<style lang="less" scoped>
.step-model {
    &.mobileDevice {
        .content {
            padding: 0 26px;
            position: relative;
            .close {
                position: absolute;
                top: -40px;
                right: 20px;
                width: 32px;
                height: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 4px 4px 4px 4px;
                cursor: pointer;

                &:hover {
                    background: rgba(239, 239, 239, 1);
                }

                img {
                    width: 16px;
                    height: 16px;
                }
            }

            .step-box {
                height: 70px;
                margin: 10px 0 0px;
                text-align: center;
                .m-title {
                    font-size: 20px;
                    color: #31302EFF;
                    font-weight: 600;
                    position: relative;
                    margin-bottom: 10px;
                    &::before {
                        display: inline-block;
                        content: '1';
                        color: #fff;
                        background: #4945FFFF;
                        width: 22px;
                        height: 22px;
                        border-radius: 100%;
                        margin-right: 10px;
                    }
                    &.two {
                        &::before {
                            content: '2';
                        }
                    }
                    &.three {
                        &::before {
                            content: '3';
                        }
                    }
                }
                .s-title {
                    font-size: 12px;
                    color:#31302E99 ;
                }
            }

            .center {
                // background: #fff;
                // padding: 24px;
                border-radius: 20px;
            }
        }
        .footer-btn {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 10px;
            padding-right: 20px;
            .y-btn {
                // width: 80px;
                padding: 0 24px;
                line-height: 40px;
                text-align: center;
                height: 40px;
                font-weight: 500;
                border-radius: 8px 8px 8px 8px;
                font-size: 14px;
                margin-left: 14px;
                cursor: pointer;
            }

            .cancel {
                border: 1px solid rgba(141, 141, 168, 0.4);
                color: rgba(49, 48, 46, 1);
                background-color: #fff;
                &:hover {
                    background: rgba(245, 246, 248, 1);
                }
            }

            .ok {
                background: #4945ff;
                color: #fff;

                &:hover {
                    background: rgba(104, 100, 255, 1);
                }
            }
        }
    }
}
</style>
